import React from 'react';


export default class Biset extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;
    const video = '292714370';
    return(
      <div>
        <div>Usamos muito essa variável no Foco90. Excelente para dar intensidade e otimizar os treinos. Exemplos no final do vídeo.</div>
          <iframe
            className='vimeo-video'
            src={`https://player.vimeo.com/video/${video}?autoplay=1&loop=1&autopause=0`}
            height="300"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true">
          </iframe>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Biset.js